import { HttpResult } from "widgets-for-react"
import { FormstackForm } from "./formstack_types"

export const loadFormstackForm = async (formId: string): Promise<HttpResult<FormstackForm>> => {
  let headers = new Headers()
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  const res = await fetch(`/api/v1/formstack/form/${formId}`, {
    method: 'GET',
    credentials: 'include',
    headers: headers
  })

  if (400 <= res.status && res.status < 500)
    return { kind: 'unauthorized', status: res.status }

  if (res.status >= 500)
    return { kind: 'failed', status: res.status }

  const json = await res.json() as FormstackForm

  return {
    kind: 'result',
    status: 200,
    value: json
  }
}